import { Component, OnInit, AfterViewInit, OnChanges, Input, ViewChild, SimpleChange, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/modal';
import { EmpresasService } from 'app/_services/empresas.service';

@Component({
  selector: 'modalnormasempresasafectadas',
  templateUrl: './modalnormasempresasafectadas.component.html',
  styleUrls: ['./modalnormasempresasafectadas.component.css']
})
export class ModalnormasempresasafectadasComponent implements OnInit, AfterViewInit, OnChanges{

  @Input() _mostrarmodal: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;
  @Input() _id_norma: any; 

  @Output() onChangeModal = new EventEmitter<any>();

  mostrarmodal: boolean = false;
  idNorma: any;
  accion = '';
  filterQueryEmpresas: any;
  filterQueryDelegados: any;

  listaEmpresas: any;
  listaDelegados: any;
  listaDelegadosEmail ='';
  asuntoEmail= '';


  constructor(private empresasService:EmpresasService) { }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }

    if (changes['_id_norma']){
      this.idNorma = changes['_id_norma'].currentValue;
    }
    
    this.getEmpresasNorma(this.idNorma);
    this.getEmpresasNormaDelegados(this.idNorma);

  }

  ngOnInit() {

    
  }

  ngAfterViewInit(){
    this.abrirModal();
  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(value: number){
    if (value == 0){
      this.onChangeModal.emit(0);
    }else if (value ==1 ){
      this.onChangeModal.emit(1);
    }
    
  }

  getEmpresasNorma(id_norma:number){
    this.empresasService.getEmpresasNorma(id_norma).subscribe(
      data => {
        if (data){
          this.listaEmpresas = data.json().empresas;
          if (this.listaEmpresas.length > 0){
            this.asuntoEmail = 'Se ha modificado la norma:  ' + this.listaEmpresas[0].abr;
          }else{
            console.log('no hay empresas');
         //   this.cerrarModal(1);
          }
         
           
        }
      })
   }
  
   getEmpresasNormaDelegados(id_norma:number){
    this.empresasService.getEmpresasEvidenciasDelegados(id_norma).subscribe(
      data => {
        if (data){
          this.listaDelegados = data.json().delegados;
          if (this.listaDelegados.length > 0){
            for (let delegado of this.listaDelegados){
              this.listaDelegadosEmail = this.listaDelegadosEmail + delegado.email + ';';
            }
            this.listaDelegadosEmail  = this.listaDelegadosEmail.slice(0, -1);
           }else{
            console.log('no hay delegados');
          }
        }
      })
   }


}



// WEBPACK FOOTER //
// ./src/app/normas/modalnormasempresasafectadas.component.ts